import NumberPickerTab from '@template/blocks/NumberPickerSection/component/NumberPickerTabs/NumberPickerTab';
import { useState } from 'react';
import * as S from './styles.ts';
import NumberTransferTab from '@template/blocks/NumberPickerSection/component/NumberPickerTabs/NumberTransferTab';
import { useRouter } from '@/lib/helpers/hooks/useRouter.ts';
import RefreshCcw from '@template/icons/RefreshCcw.tsx';
import Phone from '@template/icons/Phone.tsx';
import { TTab } from '@template/components/Tabs';
import { Tabs } from '@template/components';

export interface INumberPickerTabsProps {
  countryCode?: string;
  areaCode?: string;
  defaultKey: string;
  type?: string;
  context?: 'virtualLandline';
}

const NumberPickerTabs = ({
  countryCode,
  areaCode,
  defaultKey,
  type,
  context,
}: INumberPickerTabsProps) => {
  const router = useRouter();
  const tabs: TTab[] = [
    {
      key: 'buy',
      label: {
        startContent: <Phone />,
        value: 'Buy Phone Numbers',
      },
      content: (
        <NumberPickerTab
          defaultCountryCode={countryCode}
          defaultAreaCode={areaCode}
          defaultType={type}
          context={context}
        />
      ),
    },
    {
      key: 'transfer',
      label: {
        startContent: <RefreshCcw />,
        value: 'Transfer Phone Numbers',
      },
      content: <NumberTransferTab />,
      disabled: context === 'virtualLandline',
    },
  ];

  const [tab, setTab] = useState(defaultKey as any);

  const handleTabChange = (t: string) => {
    // Number picker tabs do not link to different routes in virtual landline context
    if (context !== 'virtualLandline') {
      setTab(t);
      router.push(
        t === 'buy'
          ? '/phone-number/all-numbers'
          : '/phone-number/keep-my-number'
      );
    }
  };

  return (
    <S.NumberPickerTabsWrapper>
      <S.NumberPickerTabsContainer>
        <Tabs
          tabs={tabs}
          selected={tab}
          defaultSelected={defaultKey}
          onTabChange={handleTabChange}
        />
      </S.NumberPickerTabsContainer>
    </S.NumberPickerTabsWrapper>
  );
};

export default NumberPickerTabs;
